import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_database/database-main";

export const Route = createFileRoute("/_authenticated/database-main")({
  head: () => ({
    meta: [
      { title: "Banco de dados — Milky Moo Palmares" },
      {
        name: "description",
        content: "Ferramentas de visualização, exportação e histórico do banco de dados.",
      },
      { property: "og:title", content: "Banco de dados — Milky Moo Palmares" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});